<template>
    <iframe 
        v-bind:src="frameSource"
        width="100%"
        height="600"
    >    
    </iframe>
</template>

<script>
    import templateApi from '../../../Api/template-manager';

    import { errorGrowl } from '../../../Util/growler';
    
    export default {
        name: "template-preview",
        created(){
            // const vm = this;
            
            // templateApi.getTemplatePreview(vm.templateId)
            //     .then(
            //         html => vm.previewHTML = html,
            //         err => errorGrowl(err)
            //     );
        },
        computed: {
            frameSource(){
                const vm = this;

                return templateApi.getTemplatePreviewUrl(vm.templateId);
                
                // const previewUrl = 'Templates/Preview/' + vm.templateId;
                
                // return `data:text/html,${encodeURIComponent(vm.previewHTML)}`
            }
        },
        data(){
            return {
                // previewHTML: null
            }
        },
        props: {
            templateId: {
                type: String,
                Required: true
            }
        }
    };
</script>

<style scoped>

</style>
